import _offsets from './offsets.json';
const offsets = _offsets;
export const calculateAlignmentOffset = (characters) => {
    if (typeof characters === 'string') {
        const offset = offsets[characters.charAt(0)];
        if (offset) {
            return `${Math.abs(offset / 1000) * -1}em`;
        }
    }
    return undefined;
};
